<!-- <div class="card animated fadeInLeftBig">
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div class="card-body">
    <div *ngIf="embedConfig && embedConfig.accessToken">
      <ngx-powerbi-component type="report" id="{{embedConfig.id}}" embedUrl="{{embedConfig.embedUrl}}" tokenType="AAD"
        accessToken="{{embedConfig.accessToken}}" on-embedded="onEmbedded($event)" [options]="options"
        style="border: 0px !important;">
      </ngx-powerbi-component>
    </div>
    <div *ngIf="embedConfig && !embedConfig.accessToken" id="pbi-container"></div>
  </div>
</div> -->

<div class="card animated fadeInLeftBig">
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div class="card-body">
    <div *ngIf="joseToken && joseToken.message" class="regulatory_body_card">
      <iframe width="100%" height="100%" [src]="streamlitUrl | safe"></iframe>
    </div>
  </div>
</div>